// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"ef489873","732":"51f4ec9d","977":"226c4d22"}[chunkId] + ".chunk.js";
};